// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__17MTa","footer":"Form_footer__1CsEw"};